import { Component } from '@verndale/core';
import { debounce } from '../helpers';

class MediaMasthead extends Component {
  resizeObserver: ResizeObserver;
  isProgramMasthead: boolean;

  constructor(el: HTMLElement) {
    super(el);

    this.resizeObserver = new ResizeObserver(this.updateVWProperty);
    this.resizeObserver.observe(document.documentElement);

    this.isProgramMasthead = this.el.classList.contains('program-masthead');
    this.dom = {
      programFeaturesRowInner: this.el.querySelector('.program-features-row__inner') as HTMLElement,
      programFeaturesRowCard: this.el.querySelectorAll(
        '.program-features-row__card'
      ) as NodeListOf<HTMLElement>,
      mediaMastheadInner: this.el.querySelector('.media-masthead__inner') as HTMLElement
    };

    //this.programInnerResize();
  }

  setupDefaults() {
    this.dom = {
      el: this.el
    };
  }

  addListeners() {
    //window.addEventListener('resize', debounce(this.programInnerResize.bind(this), 250));
  }

  updateVWProperty = debounce(() => {
    document.documentElement.style.setProperty(
      '--vw',
      `${document.documentElement.clientWidth / 100}px`
    );
  }, 250);

  programInnerResize() {
    if (this.isProgramMasthead) {
      const cardsLength = (this.dom.programFeaturesRowCard as NodeListOf<HTMLElement>)?.length || 0;
      let programFeaturesRowWidth = (this.dom.programFeaturesRowInner as HTMLElement).offsetWidth;

      if (programFeaturesRowWidth < 1439) {
        programFeaturesRowWidth = document.documentElement.clientWidth - 82;
      }

      if (cardsLength > 4) {
        // we need the width of the programFeaturesRow minus the last 2 cards if there are more than 5 cards
        const lastCardWidth = (this.dom.programFeaturesRowCard as NodeListOf<HTMLElement>)[
          cardsLength - 1
        ].offsetWidth;
        const secondLastCardWidth = (this.dom.programFeaturesRowCard as NodeListOf<HTMLElement>)[
          cardsLength - 2
        ].offsetWidth;

        const newWidth = `${programFeaturesRowWidth - lastCardWidth - secondLastCardWidth + 1}px`;
        (this.dom.mediaMastheadInner as HTMLElement).style.maxWidth = newWidth;
      }
    }
  }
}

export default MediaMasthead;
